exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@media screen and (max-width: 750px) {\n.columnlistBox[data-v-74ce3f86] {\n    margin-top: 0;\n}\n.columnlistBox .column_li[data-v-74ce3f86], .columnlistBox .lastcolumn_li[data-v-74ce3f86] {\n      height: auto;\n      margin-bottom: 10px;\n}\n}\n", ""]);

